import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@1trading/react';
import { TriangleAlert } from 'lucide-react';

interface UnauthorisedActionDialogProps {
  onClose: () => void;
}

// Shown whenever a loan mutation returns HTTP 403 (the server-side staff
// allowlist is the only gate; membership is never pre-checked client-side).
export const UnauthorisedActionDialog = ({ onClose }: UnauthorisedActionDialogProps) => (
  <Dialog onOpenChange={(open) => (open ? undefined : onClose())} open>
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <TriangleAlert className="size-5 text-amber-500" />
          Unauthorised Action
        </DialogTitle>
        <DialogDescription>
          You are not authorised to perform this action, please contact the BOP administrator if you think this is an error. Otherwise, find a staff member with authorisation to
          perform this action on your behalf.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button onClick={onClose} type="button">
          Close
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
UnauthorisedActionDialog.displayName = 'UnauthorisedActionDialog';
